// redux/store.js
import { configureStore } from '@reduxjs/toolkit';
import appReducer from "./slices/app"
const store = configureStore({
  reducer: {
    sidebar: appReducer,
  },
});
export default store;
